import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

const HeaderCell = ({
  column,
  tableManager
}) => {
  const {
    config: {
      additionalProps: {
        headerCell: additionalProps = {}
      }
    }
  } = tableManager;
  let classNames = ('rgt-text-truncate ' + (additionalProps.className || '')).trim();
  return /*#__PURE__*/_jsx("span", { ...additionalProps,
    className: classNames,
    "data-column-id": column.id.toString(),
    children: column.label
  });
};

export default HeaderCell;